
export class Pjoint {
 
    pjointeId: number;

    dateAjout: Date;
    designation: string;
    typeclient: string;

    fileName: string;
    tablep: string;
    taille: string;
    typeMime: string;
folder:string;
}
export class Modelcores {

    modelcoresId: number;
    corp: string;
    designation: string;
    objet: string;
    projets: string;
}
